import { render } from "./ButtonSwitch.vue?vue&type=template&id=7154b551&scoped=true"
import script from "./ButtonSwitch.vue?vue&type=script&lang=js"
export * from "./ButtonSwitch.vue?vue&type=script&lang=js"

import "./ButtonSwitch.vue?vue&type=style&index=0&id=7154b551&lang=scss&scoped=true"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7154b551"]])

export default __exports__